import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardActionArea, Box, useTheme, Grid, Typography } from "@mui/material";

const RestaurantCard = ({ restaurant, index }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleClick = () => {
    navigate(`/menu/${restaurant?._id}`, { state: { restaurant } });
  };

  return (
    <Grid item size={{ xs: 6, sm: 4, md: 4 }}>
      <Card
        sx={{
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: 3,
          transition: "all 0.3s ease",
          m: 1,
          "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: 6,
          },
        }}
      >
        <CardActionArea onClick={handleClick}>
          <Box
            sx={{
              position: "relative",
              paddingTop: "100%",
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={restaurant.image}
              alt={restaurant.businessName}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </CardActionArea>
      </Card>

      <Typography variant="subtitle1" sx={{ textAlign: "center", mt: 1, width: "100%" }}>
        {restaurant.businessName}
      </Typography>
    </Grid>
  );
};

export default RestaurantCard;
